module.exports = __webpack_public_path__ + "e2a789aef61312239aeacee77cb976df.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/zh.json
// module id = 1154
// module chunks = 0